import { Component, input } from '@angular/core';
import { TaskAssignmentDto } from '../../../models/request.models';

/**
 * The matter tasks a resource is assigned to, shown when an assignments-card row is expanded.
 *
 * Deliberately a plain list rather than a second table: it is supporting detail for the row
 * above, and the card's own columns already carry the assignment. Both fields come straight
 * from the assignment DTO — `taskName` is the server-side snapshot taken when the task was
 * assigned, so it keeps reading as it did even after the external task list changes.
 */
@Component({
  selector: 'app-task-assignment-list',
  standalone: true,
  imports: [],
  templateUrl: './task-assignment-list.component.html',
  styleUrls: ['./task-assignment-list.component.scss'],
})
export class TaskAssignmentListComponent {
  /**
   * The row's assigned tasks. Defaults to empty rather than nullable: unlike the billing
   * feed there is no "we were told nothing" case to distinguish — a resource either has task
   * assignments or has none, and both the card's `?? []` and an unbound input mean the latter.
   */
  readonly tasks = input<TaskAssignmentDto[]>([]);
}
